/* FlipBuy homepage product tabs, v-1.6. Tabs with a sort order load from the collection via the Section Rendering API. */
(function () {
  function load(panel) {
    var src = panel.getAttribute('data-fbh-src');
    if (!src || panel.getAttribute('data-fbh-loaded')) return;
    panel.setAttribute('data-fbh-loaded', '1');
    fetch(src, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var rail = doc.querySelector('.fbh-rail');
        var old = panel.querySelector('.fbh-rail');
        if (rail && rail.children.length && old) old.replaceWith(rail);
        else if (old) { old.removeAttribute('aria-busy'); old.classList.remove('fbh-rail--loading'); }
      })
      .catch(function () {
        var old = panel.querySelector('.fbh-rail');
        if (old) old.remove();
      });
  }

  function init(root) {
    if (root.getAttribute('data-fbh-ready')) return;
    root.setAttribute('data-fbh-ready', '1');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.fbh-tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.fbh-panel'));

    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[j]) panels[j].hidden = !on;
      });
      if (panels[i]) load(panels[i]);
      if (focus && tabs[i]) tabs[i].focus();
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % tabs.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + tabs.length) % tabs.length, true); }
      });
      // Warm the next panel when the visitor shows intent.
      t.addEventListener('mouseenter', function () { if (panels[i]) load(panels[i]); });
    });

    var first = panels[0];
    if (first && first.getAttribute('data-fbh-src')) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { load(first); io.disconnect(); } });
        }, { rootMargin: '400px 0px' });
        io.observe(root);
      } else {
        load(first);
      }
    }
  }

  function run() { Array.prototype.forEach.call(document.querySelectorAll('[data-fbh-tabs]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
